import styles from './results-grid.module.scss';
import type { estypes } from '@elastic/elasticsearch';
import CollectionObject from 'components/collection/collection-object';
import type { MouseEvent } from 'react';
import type { IElasticObjectSearchSource } from 'helpers/collection/model';

const ObjectResultsGrid = ({
	objects,
	isDev,
	explanation,
	isLoading,
	onExplainChange,
	onResultClick,
}: IProps) => {
	return (
		<section className={styles.grid}>
			{objects.map((object, i) => {
				return (
					<CollectionObject
						key={object._id}
						isLoading={isLoading}
						showSearchDebug={isDev}
						lazyLoad={i > 4}
						enforceMaxWidth={true}
						object={object._source}
						highlights={object.highlight}
						score={object._score}
						elasticSearchId={object._id}
						handleObjectClick={() => onResultClick?.(object, i)}
						handleExplain={onExplainChange}
						explanation={explanation?._id === object._id ? explanation : null}
					/>
				);
			})}
		</section>
	);
};

interface IProps {
	isDev?: boolean;
	isLoading?: boolean;
	objects: estypes.SearchHit<IElasticObjectSearchSource>[];
	explanation: estypes.ExplainResponse<unknown>;
	onExplainChange?: (event: MouseEvent<HTMLButtonElement>) => void;
	onResultClick?: (
		object: estypes.SearchHit<IElasticObjectSearchSource>,
		index: number,
	) => void;
}

export default ObjectResultsGrid;
